import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import StrikethroughOutlinedSvg from "@ant-design/icons-svg/es/asn/StrikethroughOutlined";
import AntdIcon from "../components/AntdIcon";
var StrikethroughOutlined = function StrikethroughOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: StrikethroughOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  StrikethroughOutlined.displayName = 'StrikethroughOutlined';
}
export default /*#__PURE__*/React.forwardRef(StrikethroughOutlined);